import { http, type HttpHandler, HttpResponse } from 'msw';
import { setupWorker } from 'msw/browser';

import { config } from '~/app';
import { env } from '~/app/env';

import accountHandlers from './apiAccountMock';
import horsesHandlers from './apiHorsesMock';
import toplistHandlers from './apiToplistMock';

const remoteBlockHandlers: HttpHandler[] = [
  http.all('https://api-testing.turfmaster.de/:path*', () =>
    HttpResponse.json({ message: 'Mock API fallback blocked' }, { status: 404 }),
  ),
  http.all('https://api-staging.turfmaster.de/:path*', () =>
    HttpResponse.json({ message: 'Mock API fallback blocked' }, { status: 404 }),
  ),
  http.all('https://api.turfmaster.de/:path*', () =>
    HttpResponse.json({ message: 'Mock API fallback blocked' }, { status: 404 }),
  ),
];

let workerInstance: ReturnType<typeof setupWorker> | null = null;
let workerStarted = false;

const buildRuntimeHandlers = (): HttpHandler[] => {
  const handlers: HttpHandler[] = [];
  if (env.test || config.accountApiMockEnabled) handlers.push(...accountHandlers);
  if (env.test || config.horsesApiMockEnabled) handlers.push(...horsesHandlers);
  if (env.test || config.toplistsApiMockEnabled) handlers.push(...toplistHandlers);
  if (!config.mockApiFallThroughRemote) handlers.push(...remoteBlockHandlers);
  return handlers;
};

const apiMock = (): void => {
  if (workerStarted) return;
  if (workerInstance === null) {
    workerInstance = setupWorker(...buildRuntimeHandlers());
  }
  workerStarted = true;
  void workerInstance.start({
    quiet: true,
    onUnhandledRequest: config.mockApiFallThroughRemote ? 'bypass' : 'warn',
  });
};

export default apiMock;
